export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-14.bec35956.jpg";